import useEffectStore from "@/stores/effectStore";
import styles from "./StylesList.module.scss";
import LazyImage from "./LazyImage";
import clsx from "clsx";
import { EditorSvg, ReGenerateIcon } from "@/assets/icons";
import { useEffect, useRef } from "react";
import { getDefaultFormValue, getI18nLang } from "@/utils";
import { useTranslation } from "react-i18next";
import { I18nLangMap } from "@/constants";
import Dropdown, { Placement, Trigger } from "@/components/Dropdown";
import { TEffectTemplate } from "@/types";
import { toast } from "react-toastify";

const StylesList = () => {
  const { t, i18n } = useTranslation();
  const list = useEffectStore((state) => state.effectList);
  const isGernerating = useEffectStore((state) => state.generating);
  const currentEffect = useEffectStore((state) => state.currentEffect);
  const setCurrentEffect = useEffectStore((state) => state.setCurrentEffect);
  const containerDoms = useRef<HTMLDivElement>(null);
  const key = useEffectStore((state) => state.fileOptions?.uploadFile?.url);
  const taskList = useEffectStore((state) => state.taskList);
  const loading = useEffectStore((state) => state.effectListLoading);

  useEffect(() => {
    try {
      if (containerDoms.current && list) {
        let index = list.findIndex((items) => items.id === currentEffect?.id);
        let arr = containerDoms.current.querySelectorAll(
          `.${styles["list-tag"]}`
        );
        let doms: HTMLDivElement = arr[index] as HTMLDivElement;
        const { top: top1 } = doms.getClientRects()[0];
        const { top, height } = containerDoms.current.getClientRects()[0];
        //说明在看不见区域
        if (top1 - top >= height) {
          containerDoms.current.scrollTo(0, doms.offsetTop);
        }
      }
    } catch {}
  }, [currentEffect?.id, list]);

  const handleClickEffect = (item: TEffectTemplate) => {
    if (isGernerating) {
      toast(t("before_generate"), {
        autoClose: 3000,
        toastId: "before_generate",
        // hideProgressBar: false,
        closeOnClick: true,
        progress: undefined,
      });
      return;
    }
    const isCustomStyle = item.type === "custom";
    setCurrentEffect(item);
    if (isCustomStyle) {
      useEffectStore.getState().setCustomPanel(true, {
        ...item,
      });
      return;
    }
    const defaultValue = getDefaultFormValue(item.expand);
    useEffectStore.getState().setCollectionCusInfo({
      name: defaultValue.name || "",
      preset: defaultValue.preset || "",
      profession: defaultValue.profession || "",
    });
    const store = useEffectStore.getState();
    store.effectGernerate("effect-start");
  };

  const handleRegrenerate = (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>,
    items: TEffectTemplate
  ) => {
    e.stopPropagation();
    if (isGernerating) {
      toast(t("before_generate"), {
        autoClose: 3000,
        toastId: "before_generate",
        // hideProgressBar: false,
        closeOnClick: true,
        progress: undefined,
      });
      return;
    }
    const task = taskList.find(
      (task) =>
        task.templateId === items.id &&
        task.status === 1 &&
        task.originalImageUrl === key
    );
    if (task?.form) {
      useEffectStore.getState().setCollectionCusInfo({
        name: task.form.name || "",
        preset: task.form.preset || "",
        profession: task.form.profession || "",
      });
    }
    setCurrentEffect({ ...items });
    useEffectStore.getState().retryGenerate();
  };

  const handleEdit = (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>,
    items: TEffectTemplate
  ) => {
    e.stopPropagation();
    if (isGernerating) {
      toast(t("before_generate"), {
        autoClose: 3000,
        toastId: "before_generate",
        // hideProgressBar: false,
        closeOnClick: true,
        progress: undefined,
      });
      return;
    }
    const { setCustomPanel, setCurrentEffect } = useEffectStore.getState();
    setCustomPanel(true, { ...items });
    setCurrentEffect({ ...items });
  };
  return (
    <>
      <div ref={containerDoms} className={styles["container"]}>
        <div>
          {loading &&
            new Array(6).fill(0).map((items) => {
              return (
                <div className={clsx(styles["list-tag"])} key={items}>
                  <div className={clsx(styles["inner-image-fra"])}>
                    <div className={styles["inner-image-seat"]}>
                      <div
                        className={clsx(
                          "skeleton_loading",
                          styles["inner-loading"]
                        )}
                      ></div>
                    </div>
                  </div>
                </div>
              );
            })}
          {!loading &&
            list.map((items) => {
              const isCustomStyle = items.type === "custom";
              const isActive = currentEffect?.id === items.id;
              const task = taskList.find(
                (task) =>
                  task.templateId === items.id &&
                  task.status === 1 &&
                  task.originalImageUrl === key
              );
              const showRegenerate = !!task;
              return (
                <div
                  className={clsx(
                    styles["list-tag"],
                    isGernerating && styles["disabled"]
                  )}
                  onClick={(e) => {
                    handleClickEffect(items);
                  }}
                  key={items.id}
                >
                  <div className={clsx(styles["inner-image-fra"])}>
                    <div
                      className={clsx(
                        styles["inner-image-seat"],
                        isActive && styles["seat-active"]
                      )}
                    >
                      {!isCustomStyle && items.__showExpand__ && (
                        <Dropdown
                          trigger={Trigger.hover}
                          placement={Placement.topCenter}
                          popContent={
                            <span className="dropdown-tip">{t("custom")}</span>
                          }
                        >
                          <div
                            onClick={(el) => {
                              handleEdit(el, items);
                            }}
                            className={styles["inner-cus-tags"]}
                          >
                            <EditorSvg fill="#FFFFFF" width={16} />
                          </div>
                        </Dropdown>
                      )}
                      {showRegenerate && !isCustomStyle && (
                        <Dropdown
                          trigger={Trigger.hover}
                          placement={Placement.topCenter}
                          popContent={
                            <span className="dropdown-tip">
                              {t("regenerate")}
                            </span>
                          }
                        >
                          <div
                            onClick={(e) => {
                              handleRegrenerate(e, items);
                            }}
                            className={styles["inner-regenerate"]}
                          >
                            <ReGenerateIcon width={14} />
                          </div>
                        </Dropdown>
                      )}
                      <div>
                        <LazyImage src={items.coverUrl} />
                      </div>
                    </div>
                  </div>
                  <div className={styles["inner-title"]}>
                    {getI18nLang(items.i18nAttr, I18nLangMap[i18n.language]) ||
                      items.title}
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </>
  );
};

export default StylesList;
